module.exports = __webpack_public_path__ + "img/img2.6425f47b.jpg";